import { MeterOptions } from 'ui/chart';
import { standardChartColors } from 'ui/theme';
import { AudienceCount } from '../../../domain';

export const getMeterOptions = (values: AudienceCount[]) => {
  const colorPalette = Object.values(standardChartColors);

  return values.map<MeterOptions>(({ name, count }, i) => ({
    name,
    value: count,
    tooltipContent: name,
    color: colorPalette[i],
  }));
};
